import type { OrderDetail } from "./medusa"

/**
 * Which ready message a SITE order needs now (owners, 16 Oct 2026: "ready Instagram messages for site
 * orders, like custom orders"), with its placeholders (lib/message-defaults.ts «site.*»). The
 * customer knows the order as «#12», the number on their receipt and email.
 */
export type SiteMessageKind = "box_now_preparing" | "box_now_shipped" | "arrange" | "delivered"

export function siteMessage(order: Pick<OrderDetail, "status" | "display_id" | "ref" | "delivery" | "shipped" | "delivered" | "tracking" | "fulfillments">): { kind: SiteMessageKind; key: string; vars: Record<string, string> } | null {
  if (order.status === "canceled") return null
  const ref = order.display_id != null ? `#${order.display_id}` : order.ref
  if (order.delivered) return { kind: "delivered", key: "site.delivered", vars: { order: ref } }
  if (order.delivery === "box_now") {
    const live = order.fulfillments.filter((f) => !f.canceled_at)
    const url = live.flatMap((f) => f.tracking).find((t) => t.url)?.url ?? (order.tracking ? `https://boxnow.gr/en?track=${encodeURIComponent(order.tracking)}` : null)
    if (order.shipped && url) return { kind: "box_now_shipped", key: "site.box_now_shipped", vars: { order: ref, link: url } }
    return { kind: "box_now_preparing", key: "site.box_now_preparing", vars: { order: ref } }
  }
  return { kind: "arrange", key: "site.arrange", vars: { order: ref, delivery: order.delivery === "meetup" ? "Meet-Up" : "κατ’ οίκον παράδοση" } }
}
